<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 w-screen"
    aria-modal="true"
    role="dialog"
  >
    <div class="flex items-center min-h-screen justify-center">
      <div
        class="rounded-xl shadow-lg w-[300px] md:w-[400px] bg-white py-8 px-4 flex flex-col items-center font-poppins"
      >
        <!-- Icon -->
        <div
          class="rounded-full w-20 h-20 flex justify-center items-center bg-green-300 animate-pulse"
        >
          <icon
            name="questionmark"
            class="w-10 h-10 text-white flex justify-center items-center"
          />
        </div>

        <!-- Title -->
        <h1 class="text-[14px] md:text-[16px] font-semibold mt-4">
          Submit Confirmation
        </h1>
        <p class="mt-2 text-[12px] md:text-[13px]">
          Are you sure you want to save changes?
        </p>
        <!-- Break Line  -->
        <div class="w-full h-[1px] rounded-md bg-gray-200 mt-4"></div>
        <!-- Buttons  -->
        <div class="tracking-wide flex gap-2 mt-4">
          <button
            class="bg-red-600 p-2 px-3 text-[11px] md:text-[13px] rounded-md text-white hover:bg-white border hover:border-red-800 hover:text-red-800 hover:shadow-md"
            @click="closeModal"
          >
            No, Cancel
          </button>
          <button
            class="bg-green-600 p-2 px-3 text-[11px] md:text-[13px] rounded-md text-white hover:bg-white border hover:border-green-800 hover:text-green-800 hover:shadow-md"
            @click="toggleSave"
          >
            Yes, Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../icon.vue";
export default {
  name: "SaveChangesConfirmationPage",
  components: {
    icon,
  },
  props: {
    userdetail: Object,
  },
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
      this.$emit("close");
    },

    toggleSave() {
      console.log(
        "User Details na ga gipasa og mao ni ang i save sa database:",
        this.userdetail,
      );
      this.$emit("save", this.userdetail);
      this.isOpen = false;
    },
  },
};
</script>
